import type { ButtonComponentProps } from './Button.types'
import PrimaryButton from './Variants/Primary/PrimaryButton'
import SecondaryButton from './Variants/Secondary/SecondaryButton'

export const Button = (props: ButtonComponentProps) => {
  if (props.variant === 'primary') {
    return <PrimaryButton {...props} />
  } 
    return <SecondaryButton {...props} />
  
}
